// extracted by mini-css-extract-plugin
export default {"mainContainer":"LogCashFlow_mainContainer__8qf2I","tabsHeader":"LogCashFlow_tabsHeader__sCv4U"};